export default __webpack_public_path__ + "static/media/Photo 9 - BR - Bonne protection.38449721.png";